import cn from "@utils/cn";
import { FC, useEffect, useState } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { BentoTextElement, BentoTextElementProps } from "@/types";

const TiledText: FC<BentoTextElementProps> = ({ entry }) => {
  const [isInsideSegmented, setIsInsideSegmented] = useState(false);

  useEffect(() => {
    const checkSegmentedControl = () => {
      setIsInsideSegmented(document.querySelectorAll(".segmented-control").length > 0);
    };

    checkSegmentedControl();
  }, []);

  return (
    <>
      <div className={cn("p-m flex flex-col rounded-lg aspect-square col-span-1", isInsideSegmented ? "bg-white" : "bg-[#F8F7F7]")}>
        <div>
          <Icon name={entry.icon?.link?.icon ?? ""} size="32" className="stroke-black" />
        </div>
        <div className="mt-[40px]">
          <div className="font-medium font-secondary text-m leading-6">{entry.title}</div>
          <div className="font-normal font-secondary text-m leading-6 mt-m">{entry.text}</div>
        </div>
      </div>
    </>
  );
};
export default TiledText;
